import { PasaTeamMemberType, PasaUpsertTeamInput, TeamManagementTeamQuery } from '@/generated/gql/graphql';

import { TeamManagementFormData } from './TeamManagement.schema';

export type TeamManagementTeamFromQuery = NonNullable<TeamManagementTeamQuery['Pasa']['team']>;

export const mapTeamToFormData = (team: TeamManagementTeamFromQuery): TeamManagementFormData => ({
  id: String(team.id),
  name: team.name ?? '',
  memberUserIds: team.users.map((user) => String(user.id)),
  memberTeamIds: team.teams.map((childTeam) => String(childTeam.id)),
  scopeIds: team.scopes.map((scope) => String(scope.id)),
});

export const mapFormToUpsertInput = (values: TeamManagementFormData): PasaUpsertTeamInput => ({
  ...(values.id ? { id: values.id } : {}),
  name: values.name.trim(),
  members: [
    ...values.memberUserIds.map((userId) => ({ memberType: PasaTeamMemberType.USER, userId })),
    ...values.memberTeamIds.map((teamId) => ({ memberType: PasaTeamMemberType.TEAM, teamId })),
  ],
  scopeIds: values.scopeIds,
});
